import { schema } from 'normalizr';

const diagnosisSchema = new schema.Entity('diagnoses');

export default diagnosisSchema;
